export const CREATE_NEW_EVENT = 'Create new event';
export const ADD_SPONSOR = 'Add sponsor';
export const EDIT_SPONSOR = 'Edit sponsor';
export const DELETE_SPONSOR = 'Delete sponsor';
export const ADD_TICKET_TIER = 'Add ticket tier';
export const CREATE_FIRST_EVENT = 'Create first event';
